import React from 'react';
import { Link } from 'react-router-dom';

export default class SearchBar extends React.Component {
  state = {
    query: ''
  }
  handleTextChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value
    })
  }
  handleSubmit = (e) => {
    e.prevetDefault();
  }
  render() {
    return (
      <div className="searchbar">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-md-6 col-xl-7">
              <p className="big-para-text">Find Financial Information, Resources</p>
              <p>Providing shareholders, analysts, investors and other stakeholders with relevant information</p>
            </div>
            <div className="col-12 col-md-6 col-xl-5">
            <form onSubmit={this.handleSubmit}>
              <div className="form-inline float-md-right">
                  <input type='search' placeholder="Enter Search" value={this.state.query} onChange={this.handleTextChange} id='query' />
                  <Link to={{ pathname: "/search", search: "?result="+this.state.query }}>
                  <button type='submit'>
                    <i className="fa fa-caret-right" aria-hidden="true"></i>
                  </button>
                </Link>
              </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}